// extracted by mini-css-extract-plugin
export default {"details":"addGroup_details__2sqR1","input":"addGroup_input__uhD7P","slide-in-bottom":"addGroup_slide-in-bottom__WcVfR"};